export default __webpack_public_path__ + "static/media/amazon-white.09e2a911.svg";